<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm" :inline="true">
      <el-form-item prop="userId" >
        <el-select v-model="queryParams.userId" filterable placeholder="代理商" @change="searchSubAgent" clearable>
          <el-option v-for="item in agentList" :key="item.userId" :label="'['+item.username+']-' + item.company"  :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="targetUserId">
       <el-select v-model="queryParams.targetUserId" filterable placeholder="下级代理商" @change="search" clearable>
          <el-option v-for="(item,index) in targetAgentList" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="missionId">
          <el-input v-model="queryParams.missionId" clearable placeholder="业务号" @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item>
          <el-date-picker
          style="margin-right:30px"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-model="dateRange"
          @change="search"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item> 
      <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search" class="button-class">搜索</el-button>
          <el-button type="primary" icon="el-icon-refresh" @click="resetQuery" class="button-class">重置</el-button>
      </el-form-item>    
    </el-form>
    <div class="table"  style="margin-top: 10px">
      <el-table v-loading="loading" :data="tableData" border  @sort-change="tableSortChange" max-height="600">
        <el-table-column prop="missionId" label="业务号" align="center" width="200px">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="directDis(scope.row)">{{ scope.row.missionId }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="company" label="代理商" align="center" width="180px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>[{{ scope.row.username }}]{{ scope.row.company }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="targetCompany" label="分配代理商" align="center" width="180px" :show-overflow-tooltip="true">
          <template slot-scope="scope" v-if="!!scope.row.targetUsername">
            <span>[{{ scope.row.targetUsername }}]{{ scope.row.targetCompany }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="订单创建时间" align="center" min-width="170px"></el-table-column>
        <el-table-column prop="totalNum" label="分配卡数量" align="center" min-width="120px"></el-table-column>
        <el-table-column prop="success" label="成功数量" align="center"></el-table-column>
        <el-table-column prop="activateNum" label="激活卡数" align="center" sortable="custom" min-width="120px"></el-table-column>
        <el-table-column prop="stopNum" label="停机卡数" align="center" sortable="custom" min-width="120px"></el-table-column>
        <el-table-column prop="first" label="一次充值" align="center" sortable="custom" min-width="130px">
          <span  slot="header">
            <el-tooltip content="单卡进行一次充值的总数统计" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
              一次充值
          </span>
          <template slot-scope="scope">
            <el-link v-if="scope.row.first>0" type="primary" :underline="false" @click="directDisNum(scope.row,1)">{{ scope.row.first }}</el-link>
            <span v-else>{{ scope.row.first }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="second"  align="center" sortable="custom" min-width="130px">
          <span  slot="header">
            <el-tooltip content="单卡进行二次充值的总数统计" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
              二次充值
          </span>
          <template slot-scope="scope">
            <el-link v-if="scope.row.second>0" type="primary" :underline="false" @click="directDisNum(scope.row,2)">{{ scope.row.second }}</el-link>
            <span v-else>{{ scope.row.second }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="three"  align="center" sortable="custom" min-width="130px">
          <span  slot="header">
            <el-tooltip content="单卡进行三次充值的总数统计" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
              三次充值
          </span>
          <template slot-scope="scope">
            <el-link v-if="scope.row.three>0" type="primary" :underline="false" @click="directDisNum(scope.row,3)">{{ scope.row.three }}</el-link>
            <span v-else>{{ scope.row.three }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="four" align="center" sortable="custom" min-width="130px">
          <span  slot="header">
            <el-tooltip content="单卡进行四次充值的总数统计" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
              四次充值
          </span>
          <template slot-scope="scope">
            <el-link v-if="scope.row.four>0" type="primary" :underline="false" @click="directDisNum(scope.row,4)">{{ scope.row.four }}</el-link>
            <span v-else>{{ scope.row.four }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="greaterOneNum"  align="center" sortable="custom" min-width="160px">
          <span  slot="header">
            <el-tooltip content="单卡进行一次以上（不包含一次）充值的总数统计" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
              一次以上充值
          </span>
          <template slot-scope="scope">
            <el-link v-if="scope.row.greaterOneNum>0" type="primary" :underline="false" @click="directDisNum(scope.row,5)">{{ scope.row.greaterOneNum }}</el-link>
            <span v-else>{{ scope.row.greaterOneNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="greaterFourNum"  align="center" sortable="custom" min-width="160px">
          <span  slot="header">
            <el-tooltip content="单卡进行四次以上（不包含四次）充值的总数统计" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
              四次以上充值
          </span>
          <template slot-scope="scope">
            <el-link v-if="scope.row.greaterFourNum>0" type="primary" :underline="false" @click="directDisNum(scope.row,6)">{{ scope.row.four }}</el-link>
            <span v-else>{{ scope.row.greaterFourNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="rechargingRate"  align="center" sortable="custom" min-width="130px">
          <span  slot="header">
            <el-tooltip content="单卡进行一次以上（不包含一次）的充值总数和划拨成功数量的比值" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
              复充率
          </span>
        </el-table-column>
        <el-table-column prop="firstRechargeRate"  align="center" sortable="custom" min-width="130px">
          <span  slot="header">
            <el-tooltip content="单次的充值总数和划拨成功数量的比值" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
              首充率
          </span>
        </el-table-column>
      </el-table>
    </div>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { userAgentList } from "@/api/api.js"; //初始化代理商
import { agentList } from "@/api/api.js"; //初始化代理商
import { userDistributionPage } from "@/api/api.js"; //获取列表
import { agentChildList } from "@/api/api.js"; 
export default {
  name:'distributionReport',
  data() {
    return {
      loading:true,
      queryParams:{
        userId:undefined,
        targetUserId:undefined,
        missionId:undefined,
      },
      agentList:[],
      targetAgentList:[],
      dateRange:[],
      tableData:[],
      page: 1,
      pageSize: 20,
      total: 0,
    };
  },
  computed: {
    adminShow : {
      get() {
          return this.$store.getters.user.userType =='1'
        }
    },
  },
  methods: {
    initUserAgentList(){
      userAgentList().then(res => {
        if (res.data.code == 200) {
          this.agentList = res.data.data;
          this.agentList.forEach((value,index)=>{
            if(!value.company){
                value.company = '';
            }
          })
        }
      });
    },
    //代理商下拉列表
    initAgentList() {
      agentList().then(res => {
        if (res.data.code == 200) {
          this.targetAgentList = res.data.data;
        }
      });
    },
    searchSubAgent(){
      if(!this.queryParams.userId){
        this.initAgentList();
        return;
      }
      let params ={
        userId:this.queryParams.userId
      }
      agentChildList(params).then(res => {
        if (res.data.code == 200) {
          this.targetAgentList = res.data.data
        }
      })
    },
    // 排序
    tableSortChange(column){
      this.queryParams.orderByColumn = column.prop;
      this.queryParams.isAsc = column.order;
      this.initData()
    },
    // 获取数据
    initData() {
      this.loading = true;
      let params = {
        model:{
          ...this.addDateRange(this.queryParams, this.dateRange)
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      userDistributionPage(params).then(res => {
        this.loading = false;
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        }
      })
    },
    // 搜索
    search(){
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery(){
      this.resetForm("queryForm");
      this.dateRange = [];
      this.search();
      this.initAgentList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    directDis(row){
      this.$router.push({name:'distribution',params:{missionId : row.missionId}});
    },
    //一次充值
    directDisNum(row,value){
      this.$router.push({name:'distribution',params:{missionId : row.missionId,chargeTime : value}});
    }
  },
  mounted() {
    if(this.adminShow){
      this.initUserAgentList();
    }
    this.initAgentList();
    this.initData();
  },
  created() {
    
  }
};
</script>
<style scoped lang="less">
</style>





















